<template>
	<div>
		<div v-if="loading">
			<div class="success--text text-h4 text-center">
				در حال دریافت اطلاعات...
			</div>
		</div>
		<div v-else>
			<div v-if="!items.length">
				<h3 class="text-center red--text">تاکنون حساب بانکی در سیستم ثبت نشده است</h3>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="primary" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن حساب بانکی
					</v-btn>
				</div>
			</div>
			<div v-else>
				<v-card v-for="(item, index) in items" :key="index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
					<v-row>
						<v-col cols="12" md="4" class="py-0 my-0">
							<v-text-field v-model="item.accountNumber" label="شماره حساب*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره حساب را وارد کنید']" required />
						</v-col>
						<v-col cols="12" md="4" class="py-0 my-0">
							<v-text-field v-model="item.bank" label="بانک*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام بانک را وارد کنید']" required />
						</v-col>
						<v-col cols="12" md="3" class="py-0 my-0">
							<v-text-field v-model="item.branch" label="شعبه*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شعبه را وارد کنید']" required />
						</v-col>
						<v-col cols="1" md="1" class="my-0 py-0 d-flex flex-column justify-center">
							<v-btn @click="remove(item, index)" class="ms-2" x-small fab dark color="pink" title="حذف">
								<v-icon>
									mdi-trash-can-outline
								</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-card>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="primary" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن حساب بانکی
					</v-btn>
				</div>
			</div>
		</div>
		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck',false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark :loading="submitLoading" @click="save">
				ذخیره
			</v-btn>
		</v-card-actions>
		<!-- <div class="d-flex align-center justify-center mt-3">
			<v-btn color="blue" dark @click="save">
				ذخیره
			</v-btn>
		</div> -->
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import _ from 'lodash'

	export default {
		name: 'BankAccounts',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				emptyId: emptyId,
				errorMessages: '',
				items: [],
				submitLoading: false,
				loading: false
			}
		},
		computed: {
			...get('appSettings', [
				'settings'
			]),
		},
		mounted() {
			this.loadData()
		},
		methods: {
			...call('appSettings/*'),
			loadData() {
				this.loading = true
				this.fetch().then(res => {
					this.items = res.bankAccountsJson ? JSON.parse(res.bankAccountsJson) : []
					this.loading = false
				})
					.catch(err => {
						toast.error(err.message)
						this.loading = false
					})
			},
			save() {
				this.submitLoading = true
				let data = _.cloneDeep(this.settings)
				data.bankAccountsJson = JSON.stringify(this.items)
				this.sync(data).then(x => {
					toast.success('اطلاعات با موفقیت ذخیره شد.')
					this.submitLoading = false
					this.$emit('callbck')
				}).catch(err => {
					toast.error(err.message)
					this.submitLoading = false
				})
			},
			remove(item, index) {
				this.items.splice(index, 1)
			},
			add() {
				let newItem = {
					accountNumber: '',
					bank: '',
					branch: '',
				}
				this.items.push(newItem)
			}
		},
	}
</script>
<style>
</style>
